import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";
export default {
    methods: {
        //JOB CATEGORY METHODS ---------------------------------------------------------------------------------------------------
        async getJobCategoryListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getJobCategoryListFromFilter', input: { filter: filter } };
            var response = await client().get(store.state.apiRouteRoot + "JobCategory/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },
        async getJobCategories() {
            var response = await client().get(`${store.state.apiRouteRoot}JobCategory`, { meta: { clientApiMethod: 'getJobCategories' } })
            return response?.data;
        },
        async getJobCategoryById(id) {
            var meta = { clientApiMethod: 'getJobCategoryById', input: { id: id } };
            var response = await client().get(`${store.state.apiRouteRoot}JobCategory/${id}`, { meta: meta })
            return response?.data;
        },
        async getJobCategoryActiveById(id) {
            var meta = { clientApiMethod: 'getJobCategoryActiveById', input: { id } };
            var response = await client().get(`${store.state.apiRouteRoot}JobCategory/${id}/GetActiveState`, { meta: meta })
            return response?.data;
        },
        async toggleJobCategoryActiveById(id) {
            var meta = { clientApiMethod: 'toggleJobCategoryActiveById', input: { id } };
            var response = await client().patch(`${store.state.apiRouteRoot}JobCategory/${id}/ToggleActive`, null, { meta: meta })
            return response?.data;
        },
         async createJobCategory(newJobCategory) {
            var meta = {
                clientApiMethod: 'createJobCategory',
                input: { newJobCategory },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.job.job_category") })
            }
            var response = await client().put(`${store.state.apiRouteRoot}JobCategory`, newJobCategory, { meta: meta })
            return response?.data;
        },
        async changeJobCategory(updatedJobCategory) {
            var meta = {
                clientApiMethod: 'changeJobCategory',
                input: { updatedJobCategory },
                //successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.job.job_category") })
            }
            var response = await client().patch(`${store.state.apiRouteRoot}JobCategory`, updatedJobCategory, { meta: meta })
            return response?.data;
        },
        
        //JOB CATEGORY ARTICLE METHODS -------------------------------------------------------------------------------------------
        async getJobCategoryArticlesFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getJobCategoryArticlesFromFilter', input: { filter: filter } };
            var response = await client().get(`${store.state.apiRouteRoot}JobCategoryArticles/Filtered`, { params: filter, signal: cancelationToken, meta: meta });
            return response?.data;
        },
        async addArticleToJobCategory(jobCategoryId, selectionFilter) {
            var meta = {
                clientApiMethod: 'addArticleToJobCategory',
                input: { jobCategoryId, selectionFilter },
                //successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.counter.counter") })
            }
            var response = await client().post(`${store.state.apiRouteRoot}JobCategoryArticles/${jobCategoryId}`, selectionFilter, { meta: meta });
          
            return response?.data;
        },
         async changeJobCategoryArticle(jobCategoryArticle) {
            var meta = {
                clientApiMethod: 'changeJobCategoryArticle',
                input: { jobCategoryArticle },
                //successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.counter.counter") })
            }
            var response = await client().put(`${store.state.apiRouteRoot}JobCategoryArticles/`, jobCategoryArticle, { meta: meta });
          
            return response?.data;
        },
        async removeArticleFromJobCategory(jobCategoryArticleId) {
            var meta = {
                clientApiMethod: 'removeArticleFromJobCategory',
                input: { jobCategoryArticleId },
                //successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.counter.counter") })
            }
            var response = await client().delete(`${store.state.apiRouteRoot}JobCategoryArticles/${jobCategoryArticleId}`, null, { meta: meta });
            return response?.data;
        },
    }
}